import { IUntypedCommand, Topics } from '@zaplify/common';
import { CreateProspectDataDto } from '../prospects';

export class ImportProspectsCommand extends IUntypedCommand {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly userId: string, readonly prospectsData: CreateProspectDataDto[]) {
        super();
    }
}
